export default "__VITE_ASSET__DMHzRZJt__"